module.exports = __webpack_public_path__ + "static/media/setting-policy.5cf7f223.svg";